/* @flow */

import * as React from 'react';
import {Body} from '../typography';
import './error-message.css';

type Props = {
    as: string,
    children: React.Node,
};

ErrorMessage.defaultProps = {
    as: 'div',
};

export function ErrorMessage({children, as: Tag}: Props) {
    return (
        <Tag styleName='error'>
            <Body>{children}</Body>
        </Tag>
    );
}
